export * from './message-info.component';



// WEBPACK FOOTER //
// ./src/app/modules/shared/component/message-info/index.ts